import {OktaAuth} from '@okta/okta-auth-js'
import {ApolloClient, HttpLink, InMemoryCache} from "@apollo/client";

export class GraphQlService {
    apolloClient: ApolloClient<any>;

    constructor(oktaAuth: OktaAuth, endPoint: string) {
        const httpLink = new HttpLink({
            uri: endPoint,
            headers: {
                Authorization: `Bearer ${oktaAuth.getAccessToken()!}`,
            },
        });

        this.apolloClient = new ApolloClient({
            link: httpLink,
            cache: new InMemoryCache(),
        });
    }
}